import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
} from "@angular/core";
// services
import { ErrorHandler } from "../../../services/error-handler.service";
// models
import { AppState } from "../../../../booking/models/app-state.interface";
import { ModalData } from "../../../models/modal.interface";
// ngrx store
import { Store } from "@ngrx/store";
// globals
import { ABC_PARTNERS } from '../../../../shared/globals';

@Component({
  selector: 'app-associated-flights',
  templateUrl: './associated-flights.component.html',
  styleUrls: ['./associated-flights.component.scss']
})
export class AssociatedFlightsComponent implements OnInit {

  @Input()
  modalData: ModalData;

  public modalList: Array<any> = [];
  public airlineName: string = '';

  constructor(
    private _errorService: ErrorHandler,
    public appStore: Store<AppState>,
  ) {}

  ngOnInit() {
    this.airlineName = ABC_PARTNERS.find(partner => partner.code === this.modalData.image.toLocaleUpperCase())?.codeName;
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes)
    if (changes) {

    }
  }

  close(event) {
    this._errorService.modalItem$.next("remove");
  }

}
